module.exports = __webpack_public_path__ + "static/media/cancel.b1aecd10.png";